import { useContext, useEffect, useRef, useState } from 'react';
import { getCustomisationFieldData, getCustomisationValue, getGroupData, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleNumericalInput from '../../components/ModuleNumericalInput';
// import './CustomModule.scss';
import { changeNumericalFieldValue, changeStringFieldValue, changeValue_noType } from '../../ModuleList';
import ModuleTextInput from '../../components/ModuleTextInput';
import { ShowColorPicker } from '../../../../../../forms/ColorPicker/ColorPickerPopUp';
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";

import ImageIcon from '../../../../WorkspaceAssets/ListIcons/image-icon.png';
import { COLOUR_NAME_TO_COLOUR_HEX } from '../../../../../../../helpers/Colours';
import { WORKING_ON_NODE_DATA } from '../../../EditablePreview/VisualisedComponents/VisualisedNode';

const DropdownField = (props) => {
    const fieldData = props.fieldData;
    const moduleConfig = props.moduleConfig;
    const groupConfig = props.groupConfig;
    const customisationVars = props.customisationVars;

    // const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    // console.log("Custom dropdown: Rendering with fieldData:", fieldData, "and customisationVars:", customisationVars);
    // console.log(props);

    let optionsData = null;
    let hasDynamicOptions = false;
    let realDynamicOptions = [];
    if (fieldData?.customFieldConfig?.dataLink && props.selectedFeatureNode) {
        optionsData = getCustomisationFieldData(props.campaignData, props.selectedFeatureNode.path, fieldData.customFieldConfig.dataLink);
        if (optionsData && optionsData.valOptions && Array.isArray(optionsData.valOptions)) {
            for (let i = 0; i < optionsData.valOptions.length; i++) {
                if (getCustomisationValue(customisationVars, optionsData.valOptions[i].label, 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) || getCustomisationValue(customisationVars, optionsData.valOptions[i].value, 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                    hasDynamicOptions = true;
                    break;
                }
            }
            if (hasDynamicOptions) {
                for (let i = 0; i < optionsData.valOptions.length; i++) {
                    let pathString = null;
                    if (optionsData.valOptions[i].label.split && optionsData.valOptions[i].label.split('.').length > 1) {
                        pathString = optionsData.valOptions[i].label;
                    } else if (optionsData.valOptions[i].value.split && optionsData.valOptions[i].value.split('.').length > 1) {
                        pathString = optionsData.valOptions[i].value;
                    }
                    // console.log("Custom dropdown: Processing option:", optionsData.valOptions[i], "with pathString:", pathString);
                    if (pathString) {
                        const key = pathString.split('.').pop();
                        const dataList = getGroupData(customisationVars, pathString, -1, true);
                        if (dataList && dataList.length > 0 && dataList[0][key] !== undefined) {
                            for (let j = 0; j < dataList.length; j++) {
                                const optionLabel = dataList[j][key];
                                realDynamicOptions.push({ label: optionLabel, value: j });
                            }
                        }
                    } else {
                        realDynamicOptions.push(optionsData.valOptions[i]);
                    }
                }
            }
        }
    }
    const findDisplayValue = (value) => {
        // console.log("Custom dropdown: Finding display value for:", value, optionsData, typeof value);
        const option = optionsData?.valOptions?.find(opt => (opt.value === value || opt.val === value));
        if (option) return option.label;
        if (value === '' || value === null || typeof value === 'undefined') {
            return optionsData?.valOptions?.[0]?.label ?? value;
        }
        return value;
    }

    const testIfValueIsValid = (value) => {
        const option = optionsData?.valOptions?.find(opt => (opt.value === value || opt.val === value));
        // console.log("Custom dropdown: Testing if value is valid:", value, option);
        return option !== undefined;
    }
    const replaceInvalidValue = (value) => {
        if (!testIfValueIsValid(value)) {
            if (value !== '' && value !== null && typeof value !== 'undefined') {
                return value;
            }
            // console.log("Custom dropdown: Value is invalid, replacing with default.", optionsData);
            if (optionsData?.valOptions?.length > 0) {
                // console.log("Custom dropdown: Replaced value:", optionsData.valOptions[0]?.value ?? optionsData.valOptions[0]?.val);
                return optionsData.valOptions[0]?.value ?? optionsData.valOptions[0]?.val;
            }
            return value;
        }
        return value;
    }

    const initialValue = replaceInvalidValue(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    const [currentValue, setCurrentValue] = useState(initialValue);
    const [valueType, setValueType] = useState(typeof currentValue);
    const valueType_ref = useRef(valueType);
    useEffect(() => {
        setCurrentValue(initialValue/*replaceInvalidValue(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null)*/);
        const newValueType = typeof replaceInvalidValue(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode));
        setValueType(newValueType);
        valueType_ref.current = newValueType;
    }, [customisationVars, fieldData, props.index, props.visualisationComponentKey, props.selectedFeatureNode, initialValue]);

    const changeFieldValue = (fieldId, value) => {
        const valueType_loc = valueType_ref.current;
        WORKING_ON_NODE_DATA.fieldData = fieldData;
        WORKING_ON_NODE_DATA.node = props.selectedFeatureNode;
        // console.log("Custom dropdown: Changing field value:", fieldId, value, typeof value, valueType_loc);
        let valChanged = false;
        switch (valueType_loc) {
            case 'number':
                valChanged = changeNumericalFieldValue(customisationVars, fieldData?.customFieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
                value = Number(value);
                break;
            case 'string':
                valChanged = changeStringFieldValue(customisationVars, fieldData?.customFieldConfig, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
                break;
            case 'boolean':
                valChanged = changeValue_noType(customisationVars, fieldData?.customFieldConfig, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
                value = (value === 'true' || value === 'True' || value === true);
                break;
            default:
                valChanged = changeValue_noType(customisationVars, fieldData?.customFieldConfig, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
                // console.warn("Custom dropdown: Unsupported value type:", valueType_loc);
                break;
        }
        if (valChanged) {
            setCurrentValue(value);
        }
        props?.forceUpdateComponent?.();
    }

    return (
        <>
            <div className={`v2-module-field-label${!props.isEnabled ? ' disabled' : ''}`}>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Choose'}</div>
            <ModuleTextInput
                value={findDisplayValue(currentValue)}
                fieldId={'custom-drop-down'}
                enabled={props.isEnabled && (optionsData?.valOptions?.length > 0 || (hasDynamicOptions && realDynamicOptions.length > 0))}
                editable={false}
                onChange={changeFieldValue}
                hiddenDropDown={true}
                hiddenDropDownOptions={hasDynamicOptions ? realDynamicOptions : (optionsData?.valOptions || [])}
                dropDownValue={currentValue}
            />
        </>
    );
};

export default DropdownField;